/* unplugin-vue-components disabled */import script from "./CompetitionLogTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionLogTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__